import { queryCache } from 'react-query';

import { DbFile } from '~src/types/db';
import { loadFiles } from '~src/services/api';

/** Updates a cache file entry across different queries */
export const updateCachedFile = (
  /** file id */
  id: DbFile['id'],
  /** updates to apply */
  updates: Partial<DbFile>,
  /** files query parameters for partial match  */
  queryParams: Parameters<typeof loadFiles>['1'],
  /** matching options */
  queryPredicateOptions: Parameters<typeof queryCache.getQueries>['1'] = {
    active: true,
  }
) => {
  const queries = queryCache.getQueries<DbFile[]>(
    ['files', queryParams],
    queryPredicateOptions
  );

  queries.forEach((query) => {
    query.setData((prevFiles = []) =>
      prevFiles.map((prevFile) =>
        // updated matching file
        prevFile.id !== id ? prevFile : { ...prevFile, ...updates }
      )
    );
  });
};
